module.exports = __webpack_public_path__ + "static/media/Agente.8c53220e.png";